import * as Sentry from '@sentry/node';

import { isLocalDev } from './env.ts';
import { pkg } from './package-root.ts';

const SENTRY_DSN = 'https://306d2e4389b8baa0bf14e587c2ceff04@o27611.ingest.us.sentry.io/4511229468409856';
const SENTRY_ENVIRONMENT = process.env.SL_SENTRY_ENV ?? (isLocalDev ? 'development' : 'production');

const IGNORED_ERRORS = [
  /Network Error/i,
  /Failed to fetch/i,
  /fetch failed/i,
  /ECONNREFUSED/i,
  /ENOTFOUND/i,
  /ETIMEDOUT/i,
  /Request aborted/i,
];

function isIgnoredError(message: string): boolean {
  return IGNORED_ERRORS.some((pattern) =>
    typeof pattern === 'string' ? message.includes(pattern) : pattern.test(message),
  );
}

export function initSentry(): void {
  if (isLocalDev) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: `${pkg.name}@${pkg.version}`,
    tracesSampleRate: 0,
    maxBreadcrumbs: 50,
    attachStacktrace: true,
    beforeSend(event) {
      const message = event.exception?.values?.[0]?.value ?? '';
      if (isIgnoredError(message)) {
        return null;
      }
      return event;
    },
  });

  Sentry.setTag('cli_version', pkg.version);
}

export function captureException(error: unknown, extra?: Record<string, unknown>): void {
  if (isLocalDev) {
    return;
  }
  Sentry.captureException(error, extra ? { extra } : undefined);
}

export function addBreadcrumb(breadcrumb: Sentry.Breadcrumb): void {
  if (isLocalDev) {
    return;
  }
  Sentry.addBreadcrumb(breadcrumb);
}

export async function flushSentry(timeout = 2000): Promise<void> {
  if (isLocalDev) {
    return;
  }
  await Sentry.flush(timeout);
}
